import { gql } from "@apollo/client";

export const GET_DOCUMENT_SIGNED_URL = gql`
  query GetDocumentSignedURL($params: ExtractedDocumentSignedURLParams!) {
    deductionDocumentSignedURL(params: $params) {
      signedUrl
    }
  }
`;
